import createReactComponent from '../createReactComponent';
export default createReactComponent('mood-annoyed', 'IconMoodAnnoyed', [
  ['path', { d: 'M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z', key: 'svg-0' }],
  ['path', { d: 'M15 14c-2 0 -3 1 -3.5 2.05', key: 'svg-1' }],
  ['path', { d: 'M9 10h-.01', key: 'svg-2' }],
  ['path', { d: 'M15 10h-.01', key: 'svg-3' }],
]);
